import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "new-comment" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Bijlages", -1)

import { ref } from 'vue'
import TextEditor from '@/components/TextEditor.vue'
import UploadQueue from '@/components/UploadQueue.vue'
import Uploader from '@/components/Uploader.vue'
import { NewMessageComment } from '@/types/NewMessageComment'
import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewComment',
  props: {
  messageId: String
},
  emits: ['commentCreated'],
  setup(__props, { emit }) {

const props = __props





const newComment = ref<NewMessageComment>({
  body: null,
  files: []
})

const savingComment = ref(false)

function newFileUploaded (file:File) : void {
  newComment.value.files.push(file)
}

function fileDeleted (index:number) : void {
  newComment.value.files.splice(index, 1)
}

function createComment () : void {
  savingComment.value = true

  const formData = new FormData()
  formData.append('body', newComment.value.body)

  newComment.value.files.forEach((file:File) => {
    formData.append('files[]', file)
  })

  axios.post(process.env.VUE_APP_API_URL + '/messages/' + props.messageId + '/comments', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
    emit('commentCreated')
    newComment.value = {
      body: null,
      files: []
    }
  }).finally(() => {
    savingComment.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(TextEditor, {
              content: newComment.value.body,
              onContentChange: _cache[0] || (_cache[0] = ($event: any) => (newComment.value.body = $event))
            }, null, 8, ["content"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              style: {"margin":"0 8px 8px 0"},
              disabled: !newComment.value.body || savingComment.value,
              loading: savingComment.value,
              onClick: createComment
            }, {
              default: _withCtx(() => [
                _createTextVNode("Bericht toevoegen")
              ]),
              _: 1
            }, 8, ["disabled", "loading"]),
            _createVNode(Uploader, {
              style: {"display":"inline-block"},
              onNewFileUploaded: newFileUploaded,
              "upload-button": ""
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (newComment.value.files.length)
      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(UploadQueue, {
                  "media-items": newComment.value.files,
                  onFileDeleted: fileDeleted
                }, null, 8, ["media-items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})